<glxy-form-field
  data-testid="timezoneSelector"
  (focusout)="ensureThatTimeZoneHasAValue()"
  [bottomSpacing]="bottomSpacing"
>
  <glxy-label>{{ 'GALAXY.TIMEZONE.LABEL' | translate }}</glxy-label>
  <input
    type="text"
    matInput
    [value]="currentTimezoneDisplay"
    [placeholder]="currentTimezoneDisplay"
    [required]="required"
    [formControl]="$any(control)"
    [matAutocomplete]="auto"
  />
  @if (!disabled && control?.value) {
    <button glxySuffix mat-icon-button (click)="clearInput()">
      <mat-icon class="clear-button">cancel</mat-icon>
    </button>
  }
</glxy-form-field>

<mat-autocomplete #auto="matAutocomplete">
  @for (option of timezoneOptions$ | async; track timeOptionTrack($index, option)) {
    <mat-option (onSelectionChange)="onTimeZoneChanged($event)" [value]="option.timezone">
      {{ option.display }}
    </mat-option>
  }
</mat-autocomplete>
